import { backyardCityLabel } from '@/world-prototype/places/backyardCityLabel';
import { locationBadgeSrc } from '@/world-prototype/ui/locationBadge';

/** Swap illustrated backyard badge vs plain text label. */
export function syncLocationBadge(
  labelRoot: HTMLElement,
  badgeEl: HTMLImageElement,
  placeEl: HTMLElement,
  locationId: string | null,
  fallbackLabel: string,
): void {
  const badgeSrc = locationId ? locationBadgeSrc(locationId) : null;
  if (badgeSrc) {
    badgeEl.src = badgeSrc;
    badgeEl.alt = backyardCityLabel(locationId!) ?? fallbackLabel;
    badgeEl.hidden = false;
    placeEl.hidden = true;
    placeEl.textContent = '';
    labelRoot.classList.add('wp-has-location-badge');
    labelRoot.hidden = false;
    return;
  }

  badgeEl.hidden = true;
  badgeEl.removeAttribute('src');
  placeEl.hidden = false;
  placeEl.textContent = fallbackLabel;
  labelRoot.classList.remove('wp-has-location-badge');
}
